import $ from 'jquery';

const CsrfToken = {
    name: $('meta[name=csrf-param]').prop('content'),
    value: $('meta[name=csrf-token]').prop('content'),
};

export default CsrfToken;